import './main.css';
import { Link } from "react-scroll";
import React from 'react';
import CopyBtn from './copyBtn/copyBtn'
import creative from '../../img/main/creative.png'
import creative_mob from '../../img/main/creative-mob.png'
import title from '../../img/main/title.svg'
import title_mob from '../../img/main/title_mob.svg'
import Marquee from 'react-double-marquee';

export default class Main extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            firstScreenHeight: document.documentElement.clientHeight,
        }

        this.changeScreenHeight = this.changeScreenHeight.bind(this);
    }

    changeScreenHeight() {
        this.setState({
            firstScreenHeight: document.documentElement.clientHeight
        });

        document.querySelector('.main_wrap').style.height = this.state.firstScreenHeight + 'px';
    }

    componentWillMount = () => {
        window.addEventListener("resize", this.changeScreenHeight);
        return () => window.removeEventListener("resize", this.changeScreenHeight);
    }

    componentDidMount() {
        this.changeScreenHeight();
    }

    render() {
        return (
            <div className='main_wrap'>
                <div className='main_bg'></div>
                <div className='main_grad'></div>
                <div className='container main_block'>
                    <div className='main_content main_item'>
                        <h1 className='main_title'>GPTs coding for Developers Conference'23</h1>
                        <div className='main_title_img_block'>
                            <img className='main_title_img main_title_img--pc' src={title} alt="" />
                            <img className='main_title_img main_title_img--mob' src={title_mob} alt="" />
                        </div>
                        {/* <p className='main_descr p1'>Speed up Software development by 80% with ChatGPT</p> */}
                        {/* <p className='main_date p2 grey'>Online conference on February 20-21, 2024<br/>February 20 — Frontend Day<br/>February 21 — Backend Day</p> */}
                        <p className='main_descr p1'>The conference is postponed until the beginning of summer due to the lack of reliable and valuable use cases. We don't want to provide fluff and waste your time and money like many infoproducts on the market nowadays.<br></br><br></br>Our Research Laboratories are currently working on sourcing content that truly impacts your career, but we need some more time. Thank you for your patience and understanding, we will keep you posted.</p>
                        <div className='main_btns_wrap'>
                            <Link
                                activeClass="active"
                                to='tickets'
                                spy={true}
                                smooth={true}
                                offset={80}
                                className='main_btn button'
                            >
                                Join
                            </Link>
                            <CopyBtn />
                        </div>
                    </div>
                    <div className='main_img_block'>
                        <img className='main_creative main_creative-pc' src={creative} alt="" />
                        <img className='main_creative main_creative-mob' src={creative_mob} alt="" />
                    </div>
                    <div className='main_anim'>
                        <Marquee direction='left' speed={0.03} delay={0} childMargin={0}>
                            <span className="purple"> GPTs CODING SUMMIT</span>
                            <span> GPTs CODING SUMMIT</span>
                            <span className="purple"> GPTs CODING SUMMIT</span>
                            <span> GPTs CODING SUMMIT</span>
                            <span className="purple"> GPTs CODING SUMMIT</span>
                            <span> GPTs CODING SUMMIT</span>
                            <span className="purple"> GPTs CODING SUMMIT</span>
                            <span> GPTs CODING SUMMIT</span>
                            <span className="purple"> GPTs CODING SUMMIT</span>
                            <span> GPTs CODING SUMMIT</span>
                            <span className="purple"> GPTs CODING SUMMIT</span>
                            <span> GPTs CODING SUMMIT</span>
                        </Marquee>
                    </div>
                </div>
            </div>
        )
    }
}